<template>
	<v-container fluid>
		<v-row>
			<v-col
        cols="12"
        class="d-flex justify-end py-0">
        <v-btn
          outlined
          color="primary"
          :style="btnAction.style"
					@click="getReports()">
          <v-icon left>
            mdi-reload
          </v-icon>

          Atualizar
        </v-btn>
      </v-col>

			<v-col cols="12" class="mb-2">
				<v-data-table
					class="default-table-height majorityReportTable"
					hide-default-footer
					item-key="id"
					fixed-header
					:headers="headers"
					:items="majorityReports"
					:loading="loadingMajorityReports"
					:items-per-page="itemsPerPage"
					:server-items-length="totalPages"
					:page="page"
					:custon-sort="{
						isDescending: true
					}"
					:footer-props="{
						itemsPerPageOptions: [10, 25, 50, 75, 100],
						disablePagination: loadingMajorityReports
					}"
					:mobile-breakpoint="0"
					:height="reportTableHeight"
				>
					<template v-slot:no-data>
						<span>Nenhum dado encontrado.</span>
					</template>
					<template
						v-for="header in headers"
						v-slot:[`header.${header.value}`]="{ header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on">
									{{ header.text }}
								</span>
							</template>
							<span>{{ header.text }}</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.reportLayout`]="{ header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									Arquivo de Maioridade
								</div>
							</template>
							Arquivo de Maioridade
						</v-tooltip>
					</template>
					<template v-slot:[`item.reportName`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{ item.reportName || "-" }}
								</div>
							</template>
							<span>{{ item.reportName }}</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.updatedAt`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{
										item.updatedAt
											? formatter.formatDateTimeZoneWithHours(item.updatedAt)
											: "-"
									}}
								</div>
							</template>
							<span :class="header.itemClass">
								{{ item.updatedAt ? formatter.formatDateTimeZoneWithHours(item.updatedAt) : "-" }}
							</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.createdAt`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{ formatter.formatDateTimeZoneWithHours(item.createdAt) }}
								</div>
							</template>
							<span :class="header.itemClass">{{ formatter.formatDateTimeZoneWithHours(item.createdAt) }}</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.financialGroupId`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{ item.financialGroupId ? getFinancialGroup(item.financialGroupId).name : "-" }}
								</div>
							</template>
							<div>
								{{ item.financialGroupId ? getFinancialGroup(item.financialGroupId).name : "-" }}
							</div>
						</v-tooltip>
					</template>
					<template v-slot:[`item.requestUserName`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{ item.requestUserName ? formatter.formatToTitleCase(item.requestUserName) : "-" }}
								</div>
							</template>
							<span>
								{{ item.requestUserName ? formatter.formatToTitleCase(item.requestUserName) : "-" }}
							</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.status`]="{ item, header }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on" :class="header.itemClass">
									{{ getReportsStatus(item.status) }}
								</div>
							</template>
							<span>
								{{ getReportsStatus(item.status) }}
							</span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.errors`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div v-bind="attrs" v-on="on">
									<v-btn
										color="error"
										icon
										@click="openMyReportsErrorModal(item.id)"
										:disabled="!item.hasError">
										<v-icon
											:color="item.hasError ? 'error' : ''"
											size="25">
											fas fa-times
										</v-icon>
									</v-btn>
								</div>
							</template>
							<span> Erro no relatório </span>
						</v-tooltip>
					</template>
					<template v-slot:[`item.actions`]="{ item }">
						<v-menu transition="slide-y-transition" offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip
									bottom>
									<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
										<v-btn
											:disabled="item.status != 'SUCCESS'"
											icon
											v-bind="{ ...attrs, ...tooltipAttrs }"
											v-on="{ ...on, ...tooltipOn }"
											:loading="loadingReports[item.id]"
											@click="downloadReport(item.id, item.reportName)"
										>
											<v-icon color="primary">
												mdi-tray-arrow-down
											</v-icon>
										</v-btn>
									</template>
									<span>Download</span>
								</v-tooltip>
							</template>
						</v-menu>

					</template>

					<template v-slot:footer="{ props }">
						<v-container
							fluid
							class="px-0 pt-0">
							<v-divider />
							<v-row
								justify="end"
								class="d-flex flex-row align-center fill-height px-8 pt-2"
								style="height: 70px;">
								<div
									class="d-flex flex-row align-center fill-height">
									<span
										style="margin-right: 50px;"
										:class="labelFooter.class"
										:style="labelFooter.style">
										Linhas por página
									</span>

									<v-select
										:value="itemsPerPage"
										:items="props.itemsPerPageOptions"
										hide-details
										dense
										class="footerSelectItemsPerPage primary--text mt-0"
										color="primary"
										:style="selectFooter.style"
										append-icon="mdi-chevron-down"
										@change="setSize"
									/>
								</div>

								<span
									v-if="totalPages"
									:class="labelFooter.class"
									:style="labelFooter.style">
									{{
										rangePagination
									}}
								</span>

								<v-btn
									icon
									:disabled="page === 0"
									@click="prevPage()">
									<v-icon
										size="24"
										color="primary">
										mdi-chevron-left
									</v-icon>
								</v-btn>

								<v-btn
									icon
									:disabled="((page+1) * props.pagination.itemsPerPage) >= props.pagination.itemsLength"
									@click="nextPage()"
								>
									<v-icon
										size="24"
										color="primary">
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-row>
						</v-container>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<SnackbarCustomize ref="SnackbarCustomize" />

		<MyReportsErrorModal
			ref="MyReportsErrorModal"
			defaultColor="primary"
			customDataTableId="MajorityReportsErrorTable"
			:myReportsError="propsError"
			:loadingTableMyReportsError="loadingErrorsModal"
			@cleanErrors="propsError = []"
		/>
	</v-container>
</template>

<script>

import MyReportsErrorModal from '@/components/DashboardMovementRecords/MyReports/MyReportsErrorModal.vue';
import AuthorityManagementMixin from "@/shared/mixins/authorityManagement/authorityManagementMixin";
import ReportAutomationMixin from '@/shared/mixins/reportAutomation/reportAutomationMixin';
import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import SnackbarCustomize from "@/components/CustomAlerts/SnackbarCustomize.vue";
import MyReportsService from "@/services-http/sdi/MyReportsService.js";
import MyReportsMixin from "@/shared/mixins/myReports/myReportsMixin";
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import FileDataService from '@/services-http/sdi/FileDataService';
import Formatters from "@/shared/formatters/formatters";
import { cloneDeep } from "lodash";
import { mapGetters } from 'vuex';

export default {
	name: "ReportTable",

	components: {
		SnackbarCustomize,
		MyReportsErrorModal
	},

	data: () => ({
		loadingReports: {},

		loadingMajorityReports: false,
		hasAuthorityUploadMyReports: false,
		loadingErrorsModal: false,

		reportServices: null,
		fileDataService: null,

		page: 0,
		itemsPerPage: 10,
		totalPages: 0,

		propsError: [],


		majorityReports: [],
	}),

	mixins: [
		AuthorityManagementMixin,
		ReportAutomationMixin,
		MovementRecordsMixin,
		MyReportsMixin,
		MajorityMixin,
	],

	props: {
		filter: {
			type: Object,
		}
	},

	watch: {
		filter: {
			handler(newFilter) {
				this.filterMyReports = newFilter;
			}
		}
	},

	created() {
		this.formatter = new Formatters()
	},

	async mounted() {
		this.hasAuthorityUploadMyReports = true
		this.fileDataService = new FileDataService();
		this.reportServices = new MyReportsService();
	},

	methods: {
		// Update filters and restart report search
		async handlerFilter(value, type) {
			this.page = 0;
			this.filterMyReports = cloneDeep(value);
			await this.getReports();
		},

		async prevPage() {
			this.page--;
			await this.getReports();
		},

		async nextPage() {
			this.page++;
			await this.getReports();
		},

		async setSize(size) {
			this.page = 0;
			this.itemsPerPage = size;
			await this.getReports();
		},

		// Download the selected report
		async downloadReport(id, filename) {
			this.$set(this.loadingReports, id, true);

			await this.fileDataService.DownloadReport(id).then((response) => {
        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${filename}`);
          document.body.appendChild(fileLink);

          fileLink.click();
					this.$set(this.loadingReports, id, false);
          this.$refs.SnackbarCustomize.open('success', 'Download realizado com sucesso.', 3000);
        }
      }).catch(() => {
				this.$set(this.loadingReports, id, false);
        this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar efetuar o download.');
      });
		},

		// Search reports with current filters
		async getReports() {
			this.loadingMajorityReports = true

			try {
				const filteredParams = this.getFilteredParams();
				if ('status' in filteredParams && filteredParams.status.length > 0 && filteredParams.status.includes("PARTIAL_FINISH")) {
					filteredParams.isPartialFinished = true;
				}
				const params = this.buildSearchParams(filteredParams, "search");
				await this.reportServices.GetReports(params)
					.then((response) => {
						if (response.data) {
							this.majorityReports = response.data.content;
							this.totalPages = response.data.totalElements;
						}
					})
			} catch (error) {
				this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao buscar os relatórios.');
			}

			this.loadingMajorityReports = false
		},

		// Assembles and returns the parameters of the this.filterMyReports object
		getFilteredParams() {
			return Object.entries(this.filterMyReports)
				.filter(([key, value]) => value && value !== "")
				.reduce((element, [key, value]) => ({ ...element, [key]: value }), {})
		},

		// Assembles and returns the parameters that will be sent in the request
		buildSearchParams(filteredParams, type) {
			const formattedFilterParams = cloneDeep(filteredParams)

			this.deleteEmptyParams(formattedFilterParams)

			return new URLSearchParams({
				...formattedFilterParams,
				reportLayout: 'REPORT_MAJORITY_DEFAULT',
				isRHProtegido: this.isRHProtegido,
				page: this.page,
				size: this.itemsPerPage,
				sort: "id,desc"
			})
		},

		// Remove parameters with value equal to '', null or undefined
		deleteEmptyParams(params) {
			Object.keys(params).forEach((key) => {
				if (["", null, undefined].some(item => item === params[key])) delete params[key]
			})
		},

		// Presents screen errors through the dialog component
		async openMyReportsErrorModal(reportId) {
			await this.reportServices.GetReportError(reportId).then((res) => {
				if (res && res.data && res.data.length > 0) {
					this.propsError = res.data;
				}
			}).catch(() => {
				this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao buscar os relatórios.');
			});
      this.$refs.MyReportsErrorModal.openModal();
		},

		// searches the financial group presented in the data-table
		getFinancialGroup(financialGroupId) {
			return this.financialGroups.find(el => el.id === financialGroupId) || '-'
		}
	},

	computed: {
		...mapGetters({
			isRHProtegido: 'user-info/isRHProtegido',
			financialGroups: 'financial-group/groups',
		}),

		headers() {
			return [
				{
					text: "Layout de Relatório",
					value: "reportLayout",
					align: "start",
					class: `reportLayout ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `reportLayout ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Nome do Arquivo",
					value: "reportName",
					align: "start",
					class: `reportName ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `reportName ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Grupo Financeiro",
					value: "financialGroupId",
					align: "start",
					class: `financialGroupId ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `financialGroupId ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Solicitado por",
					value: "requestUserName",
					align: "start",
					class: `requestUserName ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `requestUserName ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Data da Solicitação",
					value: "createdAt",
					align: "start",
					class: `createdAt ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `createdAt ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Data da Emissão",
					value: "updatedAt",
					align: "start",
					class: `updatedAt ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `updatedAt ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Status",
					value: "status",
					align: "start",
					class: `status ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippHeader' : ''}`,
					itemClass: `status ${this.$vuetify.breakpoint.mdAndDown ? 'platformXippTable' : ''}`,
					sortable: false
				},
				{
					text: "Erro",
					value: "errors",
					align: "start",
					class: "text--truncate",
					sortable: false
				},
				{
					text: "Ações",
					value: "actions",
					align: "start",
					class: "text--truncate",
					sortable: false
				}
			]
		},

		rangePagination() {
			const page = this.page;
      const size = this.itemsPerPage;
      const total = this.totalPages;

      const start = total === 0 ? 0 : page * size + 1;
      const end = Math.min((page + 1) * size, total);

      return `${start}–${end} de ${total}`;
		},

		reportTableHeight() {
      const viewportHeight = window.innerHeight;
      const tableHeight = -597 + viewportHeight;
      const isFullScreen = tableHeight <= 1080;
      const hasMoreThanTen = this.majorityReports && this.majorityReports.length >= 10;

      if (!hasMoreThanTen) return null;
      if (!isFullScreen) return 395;

      return tableHeight < 400 ? 260 : tableHeight;
    },
	}
}
</script>

<style lang="scss">
.reportLayout.platformXippHeader,
.reportLayout.platformXippTable {
  max-width: 65px !important;
}


.reportLayout.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reportName.platformXippHeader,
.reportName.platformXippTable {
  max-width: 115px !important;
}

.reportName.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.financialGroupId.platformXippHeader,
.financialGroupId.platformXippTable {
  max-width: 77px !important;
}

.financialGroupId.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.requestUserName.platformXippHeader,
.requestUserName.platformXippTable {
  max-width: 70px !important;
}

.requestUserName.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.createdAt.platformXippHeader,
.createdAt.platformXippTable {
  max-width: 113px !important;
}

.createdAt.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.updatedAt.platformXippHeader,
.updatedAt.platformXippTable {
  max-width: 113px !important;
}

.updatedAt.platformXippTable {
  max-width: 113px !important;
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status.platformXippHeader,
.status.platformXippTable {
  max-width: 60px !important;
}

.status.platformXippTable {
	white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.majorityReportTable {
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px color-mix(in srgb, var(--v-shadow-base) 26%, transparent) !important;

  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;

    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-muted-foreground-base) !important;

        > tr {
          height: 70px;
          max-height: 70px;
          border-radius: 5px !important;

          > th {
			  background: var(--v-muted-foreground-base) !important;
			  padding: 0 1% !important;

		   	  > span {
				color: var(--v-primary-base) !important;
				text-transform: none !important;
				font-size: 14px !important;
				font-weight: bold;
			  }
			}
        }
      }

      > tbody > tr {
        height: 70px;
        max-height: 70px;

				> td {
					padding: 0 1% !important;
					font-size: 14px !important;
					font-weight: regular;
					color: var(--v-foreground-base) !important;
				}
      }
    }
  }
}

.footerSelectItemsPerPage .v-select__selections {
  > .select__selection {
    margin: 5px 0x 3px 0 !important;
  }

  > input {
    display: none !important;
  }
}

.footerSelectItemsPerPage .v-select__selections {
  display: flex;
  justify-content: center;
  > .v-select__selection.v-select__selection--comma {
    margin: 5px 0px 3px 0 !important;
  }
}
</style>